import Banner from "../../components/common/banner";
import MoneyBackGuarantee from "../../components/common/money-back-guarantee";
import ProductLabel from "../../components/common/product-label";
import ImportantMessage from "../../components/optivista/important-message";
import CloseMessage from "../../components/optivista/close-message";
import Title from "../../components/optivista/title";
import usePageTracking from "../../utils/gtm-page-tracking";
import CountdownTimer from "../../components/common/countdown";
import Buy from "../../components/optivista/buy";
import Benefits from "../../components/optivista/benefits";
import Badges from "../../components/common/badges";
import Ingredients from "../../components/common/ingredients";
import { optiVistaIngredients } from "../../data/ingredients";
import Offer from "../../components/optivista/offer";
import productBannerImg from "../../assets/img/product-ov-banner.png";
import productBannerImgWebp from "../../assets/img/product-ov-banner.webp";
import productLabelImg from "../../assets/img/product-ov-label-bottle.png";
import productLabelImgWebp from "../../assets/img/product-ov-label-bottle.webp";
import { useEffect } from "react";
import { ovProductName } from "../../data/product";
import useBuyTracking from "../../utils/gtm-buy-tracking";
import TestimonialsOv from "../../components/optivista/testimonials-ov";

const UpsellOptivista = () => {
    usePageTracking();
    useBuyTracking();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.innerHTML = `
            var mysrc = "https://tracking.buygoods.com/track/?a=11273&firstcookie=0"+"&tracking_redirect=&referrer="+encodeURIComponent(document.referrer)+"&sessid2="+ReadCookie('sessid2')+"&product=opt1,opt3,opt6&vid1=&vid2=&vid3=&caller_url="+encodeURIComponent(window.location.href); if(typeof add_to_cart !== 'undefined') { mysrc = mysrc+'&add_to_cart='+add_to_cart; } var newScript = document.createElement('script'); newScript.type = 'text/javascript'; newScript.defer = true; newScript.src = mysrc; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(newScript, s); function ReadCookie(name){name += '='; var parts = document.cookie.split(/;\s*/);for (var i = 0; i < parts.length; i++) {var part = parts[i]; if (part.indexOf(name) == 0) return part.substring(name.length)} return '';}
        `;
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = `
           var i = document.createElement("iframe"),oid = new URLSearchParams(window.location.search);i.async = true;i.style="display:none";i.setAttribute("src", "https://buygoods.com/affiliates/go/conversion/iframe/bg?a=11273&t=d9e2485e36c8c19cbfc7f6acfe589a47&conversion=1&s="+ReadCookie('sessid2')+"&o="+oid.get('order_id_global')+"&ut="+oid.get('token'));document.body.appendChild(i); 
        `;
       
        document.head.appendChild(script1);
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return (
        <>
            <Title />
            <Banner
                productName={ovProductName}
                title1="Your Vision Can Get Better."
                title2="And It Will Get Better."
                title3="Reclaim Your Health And Independence"
                image={productBannerImg}
                imageWebp={productBannerImgWebp}
                backgroundClass="ov-bg-gradient-h"
            />
            <CloseMessage />
            <ImportantMessage />
            <Offer />
            <Benefits />
            <Badges />
            <TestimonialsOv />            
            <Ingredients
                ingredients={optiVistaIngredients}
                backgroundClass="gg-bg-solid-blue"
                title="This original blend of OptiVista<sup>23</sup> Pro Naturals contains 23 carefully selected ingredients including:"
            />
            <CountdownTimer
                title={`Get your ${ovProductName} supply today`}
                backgroundClass=""
                digitClass="ov-countdown-digit "
            />
            <Buy />
            <MoneyBackGuarantee
                productName={ovProductName}
                backgroundClass="ov-bg-gradient-h"
            />
            <ProductLabel
                image={productLabelImg}
                imageWebp={productLabelImgWebp}
                backgroundClass="ov-bg-gradient-v"
            />
        </>
    );
};

export default UpsellOptivista;